import { render } from "./LbrxTermsAndConditions.vue?vue&type=template&id=09e67023&scoped=true"
import script from "./LbrxTermsAndConditions.vue?vue&type=script&lang=js"
export * from "./LbrxTermsAndConditions.vue?vue&type=script&lang=js"

import "./LbrxTermsAndConditions.vue?vue&type=style&index=0&id=09e67023&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09e67023"]])

export default __exports__